import React from "react";
import { Link } from "react-router-dom";
import './vendora.css';
import vendora from './../images/why.svg'

const Whyvendora =() => {
    return(
        <div>
        <div className="why-vendora" id="why">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-12">
                <img src={vendora} alt="why-vendora" />
              </div>
              <div className="col-xl-6 col-12">
                <div className="vendora-management">
                  <h6>Why Vendora</h6>
                  <h1>Web-based Vendor Management Portal for Digitization & Automation</h1>
                  <p>Vendora, the web-based Digital Vendor Management Platform, enables organizations to simplify & streamline purchase processes beyond ERP. Here you can evaluate and onboard suppliers, maintain all types of master data, analyze vendor performance using score cards, MIS reports and streamline purchases as a whole.</p>
                  <Link to='https://www.vendorascmsoftware.com/about-us/' target="_blank" className="btn1">Read More</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default Whyvendora;